const ARRAY_DAYS_OF_WEEK = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]
const MONTHS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
]
/*
 * Generate open hours string based on brand opening hours and village opening hours
 */
function getOpeningHours(
  villageOpeningHours,
  globalLabels,
  {
    brandOpeningHours = {},
    brandExceptions = {},
    currentDate = new Date(),
    villageExceptions = {},
  } = {}
) {
  const normallisedDate = new Date(currentDate)
  normallisedDate.setHours(12, 0, 0, 0)
  const currentDayLabel = ARRAY_DAYS_OF_WEEK[normallisedDate.getDay()]
  const currentDateLabel = `${`0${normallisedDate.getDate()}`.slice(
    -2
  )}-${`0${normallisedDate.getMonth() + 1}`.slice(
    -2
  )}-${normallisedDate.getFullYear()}`

  const brandException = brandExceptions[currentDateLabel]
  const villageException = villageExceptions[currentDateLabel]

  const IS_BRAND_CLOSED_ON_CURRENT_WEEK_DAY =
    brandOpeningHours && brandOpeningHours[`${currentDayLabel}ClosedFlag`]
  const IS_VILLAGE_CLOSED_ON_CURRENT_WEEK_DAY =
    villageOpeningHours[`${currentDayLabel}ClosedFlag`]
  const IS_THERE_A_VILLAGE_CLOSED_EXCEPTION_FOR_CURRENT_DATE =
    villageException && villageException.closedFlag
  const IS_THERE_A_BRAND_CLOSED_EXCEPTION_FOR_CURRENT_DATE =
    brandException && brandException.closedFlag

  // if brand or village is set to be closed on current week day, show closed
  // if village has exception to be closed, it should always show closed
  // if brand has exception to be closed, it should always show closed
  if (
    IS_THERE_A_VILLAGE_CLOSED_EXCEPTION_FOR_CURRENT_DATE ||
    IS_THERE_A_BRAND_CLOSED_EXCEPTION_FOR_CURRENT_DATE
  ) {
    const exceptionClosedLabels = [brandException, villageException].filter(
      (obj) => obj && obj.label
    )
    return exceptionClosedLabels.length
      ? exceptionClosedLabels[0].label
      : globalLabels.closedLabel
  }

  // set default open and close times
  let startTime =
    brandOpeningHours && brandOpeningHours[`${currentDayLabel}OpeningTime`]
      ? brandOpeningHours[`${currentDayLabel}OpeningTime`]
      : villageOpeningHours[`${currentDayLabel}OpeningTime`]
  let endTime =
    brandOpeningHours && brandOpeningHours[`${currentDayLabel}ClosingTime`]
      ? brandOpeningHours[`${currentDayLabel}ClosingTime`]
      : villageOpeningHours[`${currentDayLabel}ClosingTime`]

  // if any village exceptions for current date
  if (villageException) {
    // set start and end time
    startTime = villageException.openingTime
    endTime = villageException.closingTime
  }

  // if there is a brand exception for current date
  if (brandException) {
    // set start and end time
    startTime = brandException.openingTime
    endTime = brandException.closingTime
  }

  // If the village is closed on current day and there are no exceptions
  // show closed
  if (IS_VILLAGE_CLOSED_ON_CURRENT_WEEK_DAY && !villageException) {
    return globalLabels.closedLabel
  }

  // If the brand is closed on current day and there are no exceptions
  // show closed
  if (IS_BRAND_CLOSED_ON_CURRENT_WEEK_DAY && !brandException) {
    return globalLabels.closedLabel
  }

  return `${startTime} – ${endTime}`
}

function getStartOfWeek(currentDate) {
  const normallisedDate = new Date(currentDate)
  normallisedDate.setHours(12, 0, 0, 0)
  const newDate = new Date(normallisedDate.getTime())
  const dayOfWeek = newDate.getDay()
  switch (dayOfWeek) {
    case 0:
      newDate.setDate(newDate.getDate() - 6)
      break
    case 1:
      break
    default:
      newDate.setDate(newDate.getDate() - (dayOfWeek - 1))
  }
  return newDate
}

function getDayName(globalLabels, day) {
  switch (day) {
    case 0:
      return globalLabels.sundayLabel
    case 1:
      return globalLabels.mondayLabel
    case 2:
      return globalLabels.tuesdayLabel
    case 3:
      return globalLabels.wednesdayLabel
    case 4:
      return globalLabels.thursdayLabel
    case 5:
      return globalLabels.fridayLabel
    case 6:
      return globalLabels.saturdayLabel
    default:
      return 'error'
  }
}

function getFootNoteAsterisk(day, openingHours) {
  if (!openingHours.footNoteCopy) {
    return ''
  }
  switch (day) {
    case 0:
      return openingHours.sundayFootnoteFlag ? '*' : ''
    case 1:
      return openingHours.mondayFootnoteFlag ? '*' : ''
    case 2:
      return openingHours.tuesdayFootnoteFlag ? '*' : ''
    case 3:
      return openingHours.wednesdayFootnoteFlag ? '*' : ''
    case 4:
      return openingHours.thursdayFootnoteFlag ? '*' : ''
    case 5:
      return openingHours.fridayFootnoteFlag ? '*' : ''
    case 6:
      return openingHours.saturdayFootnoteFlag ? '*' : ''
    default:
      return ''
  }
}

function getWeekLabel(globalLabels, weekNumber) {
  switch (weekNumber) {
    case 0:
      return globalLabels.thisWeekHeading
    case 1:
      return globalLabels.nextWeekHeading
    case 2:
      return globalLabels.followingWeekHeading
    default:
      return globalLabels.thisWeekHeading
  }
}

function getWeeklyOpeningHours(
  villageOpeningHours,
  globalLabels,
  {
    brandExceptions = {},
    brandOpeningHours = null,
    numberOfWeeks = 1,
    villageExceptions = {},
  } = {}
) {
  const startDate = getStartOfWeek(new Date())
  const openingTimes = []

  for (let j = 0; j < numberOfWeeks; j += 1) {
    const weekTimes = []
    const today = new Date()
    const todayString = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`
    const startOfWeek = new Date(startDate.getTime())
    startOfWeek.setDate(startOfWeek.getDate() + j * 7)

    for (let i = 0; i < 7; i += 1) {
      const targetDate = new Date(startOfWeek.getTime())
      targetDate.setDate(targetDate.getDate() + i)

      weekTimes.push({
        date: `${`0${targetDate.getDate()}`.slice(-2)} ${
          globalLabels[`${MONTHS[targetDate.getMonth()]}Label`]
        }`,
        day: `${getDayName(
          globalLabels,
          targetDate.getDay()
        )}${getFootNoteAsterisk(
          targetDate.getDay(),
          brandOpeningHours || villageOpeningHours
        )}`,
        openTimes: getOpeningHours(villageOpeningHours, globalLabels, {
          brandExceptions,
          brandOpeningHours,
          currentDate: targetDate,
          villageExceptions,
        }),
        isCurrentDay:
          todayString ===
          `${targetDate.getFullYear()}-${targetDate.getMonth()}-${targetDate.getDate()}`,
      })
    }

    openingTimes.push(weekTimes)
  }

  return openingTimes
}

/*
 * Reduce exceptions generate object of exceptions with key being the date
 */
function reduceExceptions(obj, exception) {
  const { date, openingTime, closingTime, closedFlag, label } = exception.node

  return {
    ...obj,
    [date]: {
      openingTime,
      closingTime,
      closedFlag,
      label,
    },
  }
}

export default {
  getOpeningHours,
  getWeeklyOpeningHours,
  getWeekLabel,
  reduceExceptions,
}
